import DatabaseModel from './DatabaseModel.js';

var Materia = Object.create(DatabaseModel);

Materia.model = 'materia';
Materia.modelFront = 'materias';

export default Materia;